import { SVGProps } from 'react';
const SvgIconAlarmBellStruck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="1em"
    viewBox="0 0 16 16"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="alarm-bell-off">
      <g id="Group 41328">
        <path
          d="M6.81641 13.7793C6.89168 14.0357 7.04797 14.2608 7.26189 14.421C7.47581 14.5811 7.73585 14.6677 8.00307 14.6677C8.2703 14.6677 8.53034 14.5811 8.74426 14.421C8.95818 14.2608 9.11447 14.0357 9.18974 13.7793"
          id="Vector"
          stroke="#10111A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.54167}
        />
        <path
          d="M8 2.66732V1.33398"
          id="Vector_2"
          stroke="#10111A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.54167}
        />
        <path
          d="M8.0013 2.66797C9.18004 2.66797 10.3105 3.13622 11.144 3.96972C11.9775 4.80321 12.4457 5.93367 12.4457 7.11241C12.4457 11.2878 13.3346 12.0013 13.3346 12.0013H2.66797C2.66797 12.0013 3.55686 10.8659 3.55686 7.11241C3.55686 5.93367 4.02511 4.80321 4.85861 3.96972C5.6921 3.13622 6.82256 2.66797 8.0013 2.66797Z"
          id="Vector_3"
          stroke="#10111A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.54167}
        />
      </g>
      <path
        d="M2.5 1.40039C5.98863 5.93502 9.76861 10.2102 13.4 14.6004"
        id="Vector 440"
        stroke="#10111A"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
  </svg>
);
export default SvgIconAlarmBellStruck;
